export default __webpack_public_path__ + "static/media/social-img-3.475cc528.jpg";